var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48.824 1h-36.648c-6.099 0-11.043 5.11-11.044 11.414v24.846c0 3.028 1.162 5.933 3.234 8.074 2.07 2.142 4.88 3.345 7.81 3.345h5.26c.25.001.451.21.452.469v12.258c.005.653.392 1.237.98 1.476.587.24 1.256.086 1.69-.387l12.44-13.674a.448.448 0 0 1 .327-.148h15.483c6.099 0 11.043-5.11 11.044-11.415v-24.847c-.003-6.296-4.937-11.402-11.028-11.411z",
  stroke: "#003a70"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.426 26.282-9.388 9.708a.756.756 0 0 1 -1.094 0l-9.371-9.686c-2.243-2.319-2.243-6.078 0-8.397a5.612 5.612 0 0 1 8.123 0l1.247 1.289a.756.756 0 0 0 1.093 0l1.268-1.31c1.443-1.54 3.577-2.158 5.584-1.615 2.007.544 3.575 2.164 4.1 4.239.526 2.074-.071 4.28-1.562 5.772",
  fill: "#ff4438",
  fillRule: "nonzero"
}));
var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 61 64",
    width: 61,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Heart.5959da2f.svg";
export { ForwardRef as ReactComponent };